import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const CYCLE_MS = 8000;

// The "thinking" indicator: a rotating, bee-themed verb ("Buzzing…", "Pollinating…") plus the
// animated dots, shown while the assistant works. Verbs come from i18n (agent.thinking-verbs) so
// they're localized. The cycle timer lives with the component, so it starts when the indicator
// appears and is cleared when it's removed.
@Component({
  selector: 'app-agent-thinking',
  templateUrl: './agent-thinking.component.html',
  styleUrls: ['./agent-thinking.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentThinkingComponent implements OnInit, OnDestroy {
  private readonly translate = inject(TranslateService);

  protected readonly verb = signal('');
  private timer: ReturnType<typeof setInterval> | undefined;

  ngOnInit(): void {
    this.pickVerb();
    this.timer = setInterval(() => this.pickVerb(), CYCLE_MS);
  }

  ngOnDestroy(): void {
    if (this.timer !== undefined) {
      clearInterval(this.timer);
    }
  }

  private pickVerb(): void {
    const verbs = this.verbs();
    if (verbs.length === 0) {
      return;
    }
    this.verb.set(verbs[Math.floor(Math.random() * verbs.length)]);
  }

  private verbs(): string[] {
    const value = this.translate.instant('agent.thinking-verbs');
    return Array.isArray(value) ? (value as string[]) : [];
  }
}
